import SubsidiaryQuery from "../../domain/core/subsidiary/SubsidiaryQuery";
import { SubsidiaryModel } from "../../domain/models/Subsidiary";
import { IQuerySubsidiaryRepository } from "../../domain/ports/subsidiary/IQuerySubsidiaryRepository";
import QueryService from "../QueryService";

export class SubsidiaryQueryService
  extends QueryService<SubsidiaryModel>
  implements IQuerySubsidiaryRepository
{
  public constructor(
    public baseURL: string,
    public pathname: string,
  ) {
    super(baseURL, pathname);
  }
}

const BASE_URL = process.env.NEXT_PUBLIC_FLUX_API_URL as string;

const subsidiaryQueryService = new SubsidiaryQuery(
  new SubsidiaryQueryService(BASE_URL, "subsidiaries"),
);

export { subsidiaryQueryService };
